import { HttpClient } from '@opallabs/api'
import loadPresentationCreationThemes from '../loadPresentationCreationThemes'

const fetchThemes = (workspaceId) =>
  HttpClient().get(`/moments/workspaces/${workspaceId}/presentation_themes`)

const getPresentationThemes = (workspaceId) => (dispatch) =>
  fetchThemes(workspaceId)
    .then((response) => {
      const themes = response.data.data.map(function (dataObject) {
        return {
          id: dataObject.id,
          name: dataObject.attributes.name,
          styles: dataObject.attributes.styles,
        }
      })
      return dispatch(loadPresentationCreationThemes(themes))
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getPresentationThemes
